import { render, staticRenderFns } from "./ConsuntiviMateriale.vue?vue&type=template&id=3eacead1&scoped=true&"
import script from "./ConsuntiviMateriale.vue?vue&type=script&lang=js&"
export * from "./ConsuntiviMateriale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eacead1",
  null
  
)

export default component.exports